import { render, staticRenderFns } from "./SystemTeachers.vue?vue&type=template&id=3e728413&scoped=true&"
import script from "./SystemTeachers.vue?vue&type=script&lang=js&"
export * from "./SystemTeachers.vue?vue&type=script&lang=js&"
import style0 from "./SystemTeachers.vue?vue&type=style&index=0&id=3e728413&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e728413",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VDataTable,VLayout,VRow,VSpacer,VTextField})
